var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "list", staticClass: "product-list" }, [
    _vm.products && _vm.products.length
      ? _c(
          "ul",
          {
            staticClass: "row",
            class: {
              "product-list__grid": _vm.viewMode === "grid",
              "product-list__list": _vm.viewMode === "list"
            }
          },
          _vm._l(_vm.productList, function(product) {
            return _c(
              "li",
              {
                key: product.id,
                staticClass: "product-list__item col-xs-6 col-sm-6 col-md-3",
                attrs: {
                  "data-gtm-product-id": "catalog-" + product.sku,
                  "data-gtm-element": "product-item"
                }
              },
              [
                _c(
                  "ProductItem",
                  _vm._b(
                    {
                      attrs: {
                        "add-to-wishlist-parent": _vm.addToWishList,
                        "remove-from-wishlist-parent": _vm.removeFromWishList
                      }
                    },
                    "ProductItem",
                    product,
                    false
                  )
                )
              ],
              1
            )
          }),
          0
        )
      : _c(
          "div",
          [
            _vm.noProductsBlock
              ? _c("div", {
                  staticClass: "category-list",
                  domProps: { innerHTML: _vm._s(_vm.noProductsBlock) }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm._t("default")
          ],
          2
        ),
    _vm._v(" "),
    _vm.maxPriceInfo
      ? _c("div", {
          staticClass: "max-price",
          domProps: { innerHTML: _vm._s(_vm.maxPriceInfo) }
        })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }